import React, { useEffect, useState } from 'react';
import { PhoneIcon, MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-black/95 backdrop-blur-md border-b border-brand-yellow/20 py-3' : 'bg-transparent py-5'}`} data-id="element-291">
      <div className="container mx-auto px-6 lg:px-12 flex justify-between items-center" data-id="element-292">
        {/* Logo */}
        <div className="flex items-center space-x-3 z-50" data-id="element-293">
          <div className="w-10 h-10 rounded-full bg-brand-black border-2 border-brand-yellow flex items-center justify-center shadow-[0_0_10px_rgba(212,168,67,0.3)]" data-id="element-294">
            <span className="text-brand-yellow font-heading font-bold text-sm" data-id="element-295">
              DE
            </span>
          </div>
          <span className="text-white font-heading font-bold tracking-widest text-lg hidden sm:block" data-id="element-296">
            DOCTOR ECOMMERCE
          </span>
        </div>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-297">
          <a href="#diagnostico" className="text-sm font-medium text-brand-gray hover:text-brand-yellow transition-colors uppercase tracking-wider" data-id="element-298">
            Diagnóstico
          </a>
          <a href="#la-cura" className="text-sm font-medium text-brand-gray hover:text-brand-yellow transition-colors uppercase tracking-wider" data-id="element-299">
            La Cura
          </a>
          <a href="#proceso" className="text-sm font-medium text-brand-gray hover:text-brand-yellow transition-colors uppercase tracking-wider" data-id="element-300">
            Proceso
          </a>
          <a href="#contacto" className="text-sm font-medium text-brand-gray hover:text-brand-yellow transition-colors uppercase tracking-wider" data-id="element-301">
            Contacto
          </a>
        </div>

        {/* Desktop CTA & Phone */}
        <div className="hidden md:flex items-center space-x-6" data-id="element-302">
          <a href="tel:4028720639" className="flex items-center text-white hover:text-brand-yellow transition-colors group" data-id="element-303">
            <PhoneIcon className="w-4 h-4 mr-2 text-brand-yellow group-hover:animate-bounce" data-id="element-304" />
            <span className="font-heading tracking-wide" data-id="element-305">(402) 872-0639</span>
          </a>
          <a href="#contact-form" className="bg-brand-yellow hover:bg-brand-yellow/90 text-brand-black font-heading font-bold text-sm px-6 py-2.5 rounded uppercase tracking-wider transition-all hover:shadow-[0_0_15px_rgba(212,168,67,0.4)]" data-id="element-306">
            Agendar Cita
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-white z-50 p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-307">
          {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-308" /> : <MenuIcon className="w-6 h-6" data-id="element-309" />}
        </button>

        {/* Mobile Menu Overlay */}
        <div className={`fixed inset-0 bg-brand-black/98 backdrop-blur-xl z-40 flex flex-col items-center justify-center space-y-8 transition-all duration-300 md:hidden ${isMobileMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`} data-id="element-310">
          <a href="#diagnostico" onClick={() => setIsMobileMenuOpen(false)} className="text-2xl font-heading text-white hover:text-brand-yellow uppercase tracking-widest" data-id="element-311">
            Diagnóstico
          </a>
          <a href="#la-cura" onClick={() => setIsMobileMenuOpen(false)} className="text-2xl font-heading text-white hover:text-brand-yellow uppercase tracking-widest" data-id="element-312">
            La Cura
          </a>
          <a href="#proceso" onClick={() => setIsMobileMenuOpen(false)} className="text-2xl font-heading text-white hover:text-brand-yellow uppercase tracking-widest" data-id="element-313">
            Proceso
          </a>
          <a href="#contacto" onClick={() => setIsMobileMenuOpen(false)} className="text-2xl font-heading text-white hover:text-brand-yellow uppercase tracking-widest" data-id="element-314">
            Contacto
          </a>

          <div className="w-16 h-px bg-brand-yellow/30 my-4" data-id="element-315"></div>

          <a href="tel:4028720639" className="flex items-center text-xl text-white" data-id="element-316">
            <PhoneIcon className="w-5 h-5 mr-3 text-brand-yellow" data-id="element-317" />
            <span className="font-heading tracking-wide" data-id="element-318">(402) 872-0639</span>
          </a>

          <a href="#contact-form" onClick={() => setIsMobileMenuOpen(false)} className="bg-brand-yellow text-brand-black font-heading font-bold text-lg px-8 py-4 rounded uppercase tracking-wider w-[80%] text-center mt-4" data-id="element-319">
            Agendar Cita
          </a>
        </div>
      </div>
    </nav>;
}